import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from 'Contexts/AuthContext';
import { RestaurantContext } from 'Contexts/RestaurantContext';
import Dashboard from './Dashboard';
import { loadForecast } from 'api/Dashboard';
import { Forecast, Restaurant, User } from 'utils/types';
import { ReservationContext } from 'Contexts/ReservationContext';
import { dateHelper } from 'utils/helper';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MobileHomepage from 'App/Mobile/Screens/Homepage/MobileHomepage';
import MobileNavBar from 'Components/Organisms/MobileNavBar';
import BottomNavBar from 'App/Mobile/Components/BottomNavBar';
import Box from 'Components/Atoms/Box';
import ToolsSurveyModal from 'App/Dashboard/Components/ToolsSurvey';

const DashboardContainer = () => {
  const { user } = useContext(AuthContext);

  const { restaurantId } = useContext(RestaurantContext);

  const { date, setdate } = useContext(ReservationContext);

  const [update, setupdate] = useState(0);

  const [forecast, setforecast] = useState<Forecast | null>(null);

  useEffect(() => {
    let isMounted = true;
    const getForecast = async () => {
      if (isMounted) {
        let answer: Forecast | null = null;
        if (!!restaurantId) {
          answer = await loadForecast(restaurantId).catch(() => null);
        }

        console.log({ restaurantId, answer });

        setforecast(answer);
      }
    };

    getForecast();

    return () => {
      isMounted = false;
    };
  }, [restaurantId, update]);

  useEffect(() => {
    if (date !== dateHelper()) setdate(dateHelper());
  }, [restaurantId, date, setdate]);

  const isMobile = useMediaQuery('(max-width: 450px)');

  if (isMobile)
    return (
      <Box>
        <MobileNavBar user={user?.data || null} />
        <MobileHomepage
          forecast={forecast}
          update={() => setupdate((x) => x + 1)}
        />
        <BottomNavBar />
        <ToolsSurveyModal key={restaurantId ?? ''} />
      </Box>
    );

  return (
    <>
      <Dashboard
        user={user?.data || null}
        forecast={forecast}
        update={() => setupdate((x) => x + 1)}
      />
    </>
  );
};

export default DashboardContainer;
